import request from "@/utils/request";

// user

export function fetchList(query) {
  return request({
    // url: '/admin/user/page',
    url: "/member/manage/page",
    method: "get",
    params: query,
  });
}

export function addObj(obj) {
  return request({
    // url: '/admin/user',
    url: "/member/info/create",
    method: "post",
    data: obj,
  });
}

export function getObj(id) {
  return request({
    url: "/admin/user/" + id,
    method: "get",
  });
}

export function delObj(id) {
  return request({
    url: "/admin/user/" + id,
    method: "delete",
  });
}

export function putObj(obj) {
  return request({
    url: "/admin/user",
    method: "put",
    data: obj,
  });
}

export function isExsit(params) {
  return request({
    url: "/admin/user/check/exsit",
    method: "get",
    params: params,
  });
}
// 编辑用户信息
export function manage(data) {
  return request({
    url: "/member/manage",
    method: "put",
    data,
  });
}

// 获取用户角色列表
export function sysRoles(data) {
  return request({
    url: `/admin/user/sysRoles?userId=${data}`,
    method: "get",
  });
}

// 账号转移
export function transfer(data) {
  return request({
    url: `/member/manage/account/transfer`,
    method: "put",
    data: data,
  });
}
// 修改用户状态 启用禁用
export function changeStatus(data) {
  return request({
    url: `/member/info/enableAndDisable`,
    method: "GET",
    params: data,
  });
}
